import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table deposit report view.
 * @extends JetView
 */
export default class recordTableDepositReportView extends JetView {
    /**
     * Configures the view layout and properties.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'package', // Column ID
                    header: _('dav'), // Column header with localization
                    fillspace: 2, // Fill space proportion
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type
                    format: dateFormat, // Formatting function for the column
                },
                {
                    id: 'maintainer', // Column ID
                    header: _('ID Usuario'), // Column header with localization
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type
                },
                {
                    id: 'architecture', // Column ID
                    header: _('Transacción ID'), // Column header with localization
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager ID for pagination
            // API endpoint for data loading
            url: devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2',
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user ID
        var url = grid.data.url; // Store the grid's URL
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        this.on(this.app, 'user:id', (Id) => {
            // Event listener for user ID changes
            grid.load(grid.data.url + '?id=' + Id); // Load data for specific user ID
        });
    }
}

// FILE DOCUMENTED
